import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DocumentsLabelConstants } from '../../../../../shared/constants/bind-and-issue.labels.constants';
import { ErrorMessageConstant } from '../../../../../shared/constants/error-message.constants';
import { GenericLabel } from '../../../../../shared/constants/generic.labels.constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { take, takeUntil } from 'rxjs/operators';
import { BaseClass } from '../../../../../shared/base-class';
import { QuickQuoteService } from '../../../../../core/services/submission/quick-quote.service';
import { PolicyBillingData } from '../../../../policy-management/data/policy-billing.data';
import { PolicyBillingLabelsConstants } from '../../../../../shared/constants/policy-billing.labels.constants';
import { BillingService } from '../../../../../core/services/billing/billing.service';
import { SuspendedPaymentsLabel } from '../../../../../shared/constants/suspended-payments.labels.constants';
import { DocumentUploadModalComponent } from '../../../../policy-management/policy-billing/payments/related-documents/document-upload-modal/document-upload-modal.component';
import { PaymentSuspendedDocDTO } from '../../../../../shared/models/data/dto/billing/payment-suspended-doc.dto';
import Utils from '../../../../../shared/utilities/utils';
import NotifUtils from '../../../../../shared/utilities/notif-utils';
import { SuspendedPaymentsData } from '../../../data/suspended-payments.data';
import { PolicyService } from '../../../../../core/services/submission/policy.service';
import { UserService } from 'app/core/services/management/user.service';
import { AuthService } from 'app/core/services/auth.service';

@Component({
  selector: 'app-britecore-suspended-payment-related-doc',
  templateUrl: './britecore-suspended-payment-related-doc.component.html',
  styleUrls: ['./britecore-suspended-payment-related-doc.component.scss']
})
export class BritecoreSuspendedPaymentRelatedDocComponent extends BaseClass implements OnInit, OnDestroy {

  public SuspendedPaymentsLabel = SuspendedPaymentsLabel;
  public ErrorMessageConstant = ErrorMessageConstant;

  @Input() suspendedPaymentId: string;
  @Input() isAdd: boolean = false;

  PolicyBillingLabelsConstants = PolicyBillingLabelsConstants;
  DocumentLabelConstants = DocumentsLabelConstants;

  GenericLabel = GenericLabel;
  isOpen: boolean = true;
  modalRef: BsModalRef | null;

  userFullName: string;

  constructor(public policyBillingData: PolicyBillingData,
    private modalService: BsModalService,
    public quickQuoteService: QuickQuoteService,
    private billingService: BillingService,
    private suspendedPaymentsData: SuspendedPaymentsData,
    private policyService: PolicyService,
    private userService: UserService,
    private authServie: AuthService) {
    super();
  }

  ngOnInit() {
    if (this.suspendedPaymentId) {
      this.suspendedPaymentsData.getDetailedSuspendedView(this.suspendedPaymentId);
      this.suspendedPaymentsData.resetDocumentVariables();
      this.loadTableItems();
    }

    this.getUserfullNameForUploadingDocs(this.authServie.getUserId());
  }

  get paymentDocumentTableRows() {
    return this.suspendedPaymentsData.paymentDocumentTableRows;
  }

  loadTableItems(): void {
    Utils.blockUI();
    this.suspendedPaymentsData.paymentDocumentTableRows = [];
    this.billingService.listSuspendedPaymentDoc(this.suspendedPaymentId).pipe(takeUntil(this.stop$)).subscribe(res => {
      if (res) {
        this.suspendedPaymentsData.paymentDocumentTableRows = res;
        this.billingService.getSuspendedPaymentDetail(this.suspendedPaymentId).subscribe(response => {
          if (response) {
            if (response.checkImgLink) {
              this.suspendedPaymentsData.paymentDocumentTableRows.push({description: 'Check Image',filePath: response.checkImgLink, imgUploadDate: response.imgUploadDate });
            }
            if (response.envelopeImgLink) {
              this.suspendedPaymentsData.paymentDocumentTableRows.push({description: 'Envelope Image',filePath: response.envelopeImgLink, imgUploadDate: response.imgUploadDate });
            }

            if (response.invoiceImgLink) {
              this.suspendedPaymentsData.paymentDocumentTableRows.push({description: 'Invoice Image',filePath: response.invoiceImgLink, imgUploadDate: response.imgUploadDate});
            }
          }
        });
      }
      Utils.unblockUI();
    });
  }

  onUploadClick(): void {
    const initialState = {
      title: this.DocumentLabelConstants.addTitle,
      hideCategoryField: true,
    };
    this.modalRef = this.modalService.show(DocumentUploadModalComponent, {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
    });

    this.modalRef.content.event.pipe(takeUntil(this.stop$)).subscribe((res) => {
      const request: PaymentSuspendedDocDTO = {
        suspendedPaymentId: this.suspendedPaymentId,
        fileName: res.data.documentFile.name,
        filePath: res.data.documentFile.name,
        description: res.data.description,
        isActive: true,
        file: res.data.documentFile,
        createdBy: res.data.uploadedBy
      };

      if (this.suspendedPaymentId) {
        this.suspendedPaymentsData.documentRequest = [];
      }

      this.suspendedPaymentsData.documentRequest.push(request);

      if (this.suspendedPaymentId) {
        this.suspendedPaymentsData.addSuspendedPaymentDoc(this.suspendedPaymentId);

        this.suspendedPaymentsData.isDocumentUploadSuccess.pipe(take(1)).subscribe(value => {
          if (value) {
            this.loadTableItems();
          }
        });
      } else {
        this.setTemporaryTableView(request);
      }
    });
  }

  onViewClick(filePath: string, fileName: string): void {
    this.policyService.generateSASURL(Utils.URLEncoder(filePath, fileName)).pipe(takeUntil(this.stop$)).subscribe(resultSASURL =>{
      window.open(resultSASURL, '_blank');
    });
  }

  onDeleteClick(document: any, index: number): void {
    if(document.id){
      NotifUtils.showConfirmMessage(this.SuspendedPaymentsLabel.relatedDocuments.deleteConfirmation, () => {
        Utils.blockUI();
        this.billingService.deleteSuspendedPaymentDoc(document.id).subscribe(_ => {
          Utils.unblockUI();
          this.loadTableItems();
        },
          err => {
            Utils.unblockUI();
            NotifUtils.showMultiLineError(err.error?.message);
          }
        );
      });
    } else {
      this.suspendedPaymentsData.paymentDocumentTableRows.splice(index, 1);
      this.suspendedPaymentsData.documentRequest.splice(index, 1);
    }
  }

  setTemporaryTableView(data: PaymentSuspendedDocDTO): void {
    const newEntry = {
      createdBy: data.createdBy ?? 0,
      createdDate: data.createdDate ?? new Date(Date.now()),
      description: data.description,
      fileName: data.fileName ?? '',
      filePath: data.filePath ?? '',
      id: data.id ?? '',
      isActive: true,
      isUploaded: true,
      riskId: null,
      suspendedPaymentId: data.suspendedPaymentId ?? '',
      createdByFullName: this.userFullName
    };
    this.suspendedPaymentsData.paymentDocumentTableRows.push(newEntry);
  }

  getUserfullNameForUploadingDocs(id: number) {
    Utils.blockUI();
    this.userService.getUserInfoById(id).subscribe(x => {
      this.userFullName = x.fullName;
      Utils.unblockUI();
    });
  }

  ngOnDestroy() {
    this.suspendedPaymentsData.resetDocumentVariables();
  }

}
